import { forwardRef, useImperativeHandle } from 'react';

import { useCommand } from '@components/features/CommandMenu/hook';
import { Command as ICommand } from '@components/features/CommandMenu/types';

const init = () => null;

export const Command = forwardRef<null, ICommand & { disabled?: boolean }>(
  function Command(props, ref) {
    useCommand(props);
    // Accept ref but don't render anything
    useImperativeHandle(ref, init);
    return null;
  }
);
